import {createContext, useContext, useState, useMemo, FC, ReactNode, useEffect} from 'react';
import {WithChildren} from '../helpers';

interface NavbarActionContextType {
	navbarNodeAction: ReactNode | null;
	shouldShowComponentAction: boolean;
	setNavbarNodeAction: (navbarAction: ReactNode | null) => void;
	setShouldShowComponentAction: (show: boolean) => void;
}

const NavbarActionContext = createContext<NavbarActionContextType>({
	navbarNodeAction: null,
	shouldShowComponentAction: false,
	setNavbarNodeAction: () => {},
	setShouldShowComponentAction: () => {},
});

export const NavbarActionProvider: FC<WithChildren> = ({children}) => {
	const [navbarNodeAction, setNavbarNodeAction] = useState<ReactNode | null>(null);
	const [shouldShowComponentAction, setShouldShowComponentAction] = useState(false);

	const value = useMemo(() => {
		return {
			navbarNodeAction,
			shouldShowComponentAction,
			setNavbarNodeAction,
			setShouldShowComponentAction,
		};
	}, [navbarNodeAction, shouldShowComponentAction, setNavbarNodeAction, setShouldShowComponentAction]);

	return <NavbarActionContext.Provider value={value}>{children}</NavbarActionContext.Provider>;
};

export const useNavbarActionComponent = () => {
	const context = useContext(NavbarActionContext);
	return context;
};

const NavbarActionComponent: FC<WithChildren> = ({children}) => {
	const {setNavbarNodeAction, navbarNodeAction} = useNavbarActionComponent();
	useEffect(() => {
		setNavbarNodeAction(children);
	}, [children, setNavbarNodeAction, navbarNodeAction]);
	return null;
};

export {NavbarActionComponent};
